module.exports = __webpack_public_path__ + "static/media/rank-icon.7762e9d5.svg";